'use client';

import { ISessionState } from '@/redux/reducer/session';
import { useSelector } from 'react-redux';

export const useSession = () => {
  const session: ISessionState = useSelector((state: any) => state.session);
  const { userSession, isLoading } = session;

  return {
    userSession,
    isLoading,
  };
};
